<template>
  <div class="footer_centre" >
    <div  class="footer_friend" v-if="0">
      <div class="heZuo">
        <div class="heZuo_title">合作伙伴</div>
        <div class="heZuo_pel">
          <img src="../assets/images/home/u1266.jpg" alt="百度">
          <img src="../assets/images/home/u1270.jpg" alt="腾讯医典">
          <img src="../assets/images/home/u1268.jpg" alt="今日头条">
        </div>
      </div>
      <div class="youQing">
        <div class="youQing_title">友情链接</div>
        <div class="youQing_pel">
          <div class="youQing_name">腾讯医典</div>
          <div class="youQing_name">今日头条</div>
        </div>
      </div>
      <div class="subscription">
        <div class="subscription_title">关注排行</div>
        <div class="subscription_pel">
          <div class="item_disease">手足口病</div>
          <div class="item_disease">小儿感冒</div>
          <div class="item_disease">小儿湿疹</div>
          <div class="item_disease">发烧</div>
          <div class="item_disease">颈椎病</div>
          <div class="item_disease">白癜风</div>
          <div class="item_disease">胃炎</div>
          <div class="item_disease">肝硬化</div>
          <div class="item_disease"> 肾结石 </div>
          <div class="item_disease">内分泌失调</div>
          <div class="item_disease">乳腺增生</div>
          <div class="item_disease">子宫肌瘤</div>
          <div class="item_disease">输卵管堵塞</div>
          <div class="item_disease">月经不调</div>
          <div class="item_disease"> 高血压</div>
          <div class="item_disease">白内障</div>
          <div class="item_disease">肝腹水</div>
          <div class="item_disease">阴道炎</div>
          <div class="item_disease">前列腺炎</div>
          <div class="item_disease">龟头炎</div>
          <div class="item_disease">艾滋病</div>
        </div>
      </div>
    </div>
    <div class="footer_logoList">
      <img width="180px" height="57px" src="../assets/images/home/u10010.png" alt="">
      <img width="200px" height="57px" src="../assets/images/home/u10086.png" alt="">
      <img width="171px" height="57px" src="../assets/images/home/u1290.png" alt="">
      <img width="164px" height="57px" src="../assets/images/home/u1288.png" alt="">
      <img width="228px" height="57px" src="../assets/images/home/u1297.png" alt="">
      <img width="250px" height="57px" src="../assets/images/home/u1008611.png" alt="">
    </div>
    <div class="footer_bottom">
      <a target="_blank" href="https://beian.miit.gov.cn/" class="one">Copyright©2018-2020 名医科普 京ICP备20027192号</a>
      <div class="two"> 广播电视节目制作经营许可证 (京)字第16040号 。</div>
      <div class="three">本网站所有文章、视频、图片等内容为名医科普所有，任何个人、组织、机构等未经允许不得擅自进行复制、修改、剪辑或以其他任何形式进行商业使用,违者究其法律责任及经济赔偿。</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>
<style lang="stylus" scoped>
  .footer_centre{
    margin-top 100px
    padding 50px 0
    width: 100%
    height: 360px
    background #d7d7d7
    .footer_friend{
      width: 1200px
      margin 0 auto
      .heZuo{
        display flex
        align-items center
        .heZuo_title{
          width: 113px;
          height: 50px;
          border-radius: 5px;
          border 1px solid #333333
          text-align: center
          line-height:50px
          margin-right 20px
          font-weight: 700;
          font-size 20px
        }
        .heZuo_pel{
          display flex
          align-items center
          >img{
            width: 99px;
            height: 30px;
            margin-right 20px
          }
        }
      }
      .youQing{
        margin-top 20px
        display flex
        align-items center
        .youQing_title{
          width: 113px;
          height: 50px;
          border-radius: 5px;
          border 1px solid #333333
          text-align: center
          line-height:50px
          margin-right 20px
          font-weight: 700;
          font-size 20px
        }
        .youQing_pel{
          display flex
          align-items center
          .youQing_name{
            display flex
            align-content center
            font-size: 24px;
            color: #333
            &:last-child{
              &:after{
                content ''
                display none
              }
            }
            &:after{
              content ''
              display block
              width: 2px;
              height: 28px;
              background #fff
              margin 0 30px
            }
          }
        }
      }
      .subscription{
        margin-top 20px
        display flex
        align-items center
        .subscription_title{
          width: 113px;
          height: 50px;
          border-radius: 5px;
          border 1px solid #333333
          text-align: center
          line-height:50px
          margin-right 20px
          font-weight: 700;
          font-size 20px
        }
        .subscription_pel{
          max-width 1000px
          height: 50px;
          display flex
          flex-wrap wrap
          align-items center
          .item_disease{
            font-size: 16px;
            color: #333
            margin-right 10px
          }
        }
      }
    }
    .footer_logoList{
      margin-top 60px
      padding 0 60px
      display flex
      justify-content space-between
      align-items center
    }
    .footer_bottom{
      margin-top 50px
      display flex
      flex-direction column
      align-items center
      .one{
        font-size: 14px;
        color: #333
        text-decoration:none;
      }
      .two {
        font-size: 14px;
        color: #333
        margin-top 10px
      }
      .three {
        width: 750px
        font-size: 14px;
        color: #333
        line-height: normal;
        margin-top 10px
        text-indent 2em
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Footer.vue